import { ActionsBase, ContextBase, InitialFlipType, RingCalibrationData, RingModel, RingTypeEnum, State, StateTransitionData, Tools } from '@ortho-next/nextray-core';
import { AppModel } from './AppModel';
import { Loading } from './Loading';

export enum StateTypes { // important: sorted by flow
	loading,
	new,
	calibrated,
	deformityAnalysis,
	EOC,
	templating,
	RPM,
	tlhex,
	tlhexSchedule
}

export interface Actions extends ActionsBase {
	setRing: { ringModel: RingModel, oppositeRingType: RingTypeEnum },
	/**
	 * Set ring calibration data (patient garage only).
	 */
	setRingCalibrationData: RingCalibrationData;
	/**
	 * Resets all image tools.
	 */
	resetImageTools: null;
}

/**
 * Manages the communications between three.js and angular part.
 */
export class Context extends ContextBase<Actions> {
	public model!: AppModel;
	public tools!: Tools;

	protected changeState(state: StateTransitionData): State<Actions> {
		return state.type == StateTypes.loading ? new Loading(this) : this._state;
	}

	constructor() {
		super();
		this._state = new Loading(this);
	}

	public setModels(model: AppModel, tools: Tools): void {
		this.model = model;
		this.tools = tools;
	}

	public updateDataToSave(): void {
		const model = this.model;
		const plane = this.tools.plane!;
		let currentPlaneRotation = plane.rotation.z;

		if (plane.flipType === InitialFlipType.horizontal || plane.flipType === InitialFlipType.vertical) {
			currentPlaneRotation *= -1;
		} else if (plane.flipType === InitialFlipType.rotate180) {
			currentPlaneRotation -= Math.PI;
		}

		model.planeRotation = plane.rotationAfterFlip + currentPlaneRotation;
		model.brightnessAP = plane.brightness;
		model.contrastAP = plane.contrast;
	}
}
